const PARTS_DATA = [

  { name: "a-c-compressor", image: "/parts/ac_compressor.webp" },

  { name: "a-c-condenser", image: "/parts/ac_condenser.webp" },

  { name: "abs-pump-modulator", image: "/parts/abs_pump.webp" },

  { name: "air-cleaner-box", image: "/parts/air_cleaner_box.webp" },

  { name: "airbag-module-sensor", image: "/parts/airbag_module_sensor.webp" },

  { name: "alternator", image: "/parts/alternator.webp" },

  { name: "bonnet", image: "/parts/bonnet.webp" },

  { name: "bonnet-hinge-strut", image: "/parts/bonnet_hinge_strut.webp" },

  { name: "bonnet-release", image: "/parts/bonnet_release.webp" },

  { name: "bootlid-tailgate", image: "/parts/bootlid_tailgate.webp" },

  { name: "bootlid-tgate-hinge", image: "/parts/bonnet_hinge_strut.webp" },

  { name: "brake-booster", image: "/parts/break_booster.webp" },

  { name: "combination-switch", image: "/parts/combination_switch.webp" },

  { name: "courtesy-light", image: "/parts/courtesy_light.webp" },

  { name: "differential-centre", image: "/parts/differential_centre.webp" },

  { name: "ecu", image: "/parts/ecu.webp" },

  { name: "engine", image: "/parts/engine.webp" },

  { name: "f-bar-reinforc-brack", image: "/parts/front_end_assy.webp" },

  { name: "fan", image: "/parts/fan.webp" },

  { name: "front-bumper", image: "/parts/front_bumper.webp" },

  { name: "front-end-assy", image: "/parts/front_end_assy.webp" },

  { name: "fuel-pump", image: "/parts/fuel_pump.webp" },

  { name: "gear-stick-shifter", image: "/parts/gear_stick_shifter.webp" },

  { name: "grille", image: "/parts/grille.webp" },

  { name: "heater-fan-motor", image: "/parts/heater_fan_motor.webp" },

  { name: "heater-ac-controls", image: "/parts/heater_ac_controls.webp" },

  { name: "instrument-cluster", image: "/parts/instrument_cluster.webp" },

  { name: "intercooler", image: "/parts/intercooler.webp" },

  { name: "left-door-mirror", image: "/parts/mirror.webp" },

  { name: "left-driveshaft", image: "/parts/drive_shaft.webp" },

  { name: "left-front-door", image: "/parts/door.webp" },

  { name: "left-front-hub-assembly", image: "/parts/hub_assembly.webp" },

  { name: "left-front-lower-control-arm", image: "/parts/control_arm.webp" },

  { name: "left-front-strut", image: "/parts/strut.webp" },

  { name: "left-front-window-reg-motor", image: "/parts/window_reg_motor.webp" },

  { name: "left-headlamp", image: "/parts/headlamp.webp" },

  { name: "left-rear-door-window", image: "/parts/door_window\.webp" },

  { name: "left-rear-door-sliding", image: "/parts/door.webp" },

  { name: "left-rear-hub-assembly", image: "/parts/hub_assembly.webp" },

  { name: "left-rear-strut", image: "/parts/strut.webp" },

  { name: "left-rear-trailing-arm", image: "/parts/trailing_arm.webp" },

  { name: "left-rear-wnd-reg-motor", image: "/parts/window_reg_motor.webp" },

  { name: "left-taillight", image: "/parts/left_taillight.webp" },

  { name: "master-cylinder", image: "/parts/master_cylinder.webp" },

  { name: "overflow-bottle", image: "/parts/overflow_bottle.webp" },

  { name: "p-s-reservoir", image: "/parts/ps_reservoir.webp" },

  { name: "parcel-shelf-cargo-blind", image: "/parts/trim_panel.webp" },

  { name: "pwr-dr-wind-switch", image: "/parts/pwr_dr_wind_switch.webp" },

  { name: "r-bar-bracket-reinfo", image: "/parts/misc_bracket.webp" },

  { name: "radiator", image: "/parts/radiator.webp" },

  { name: "radiator-support", image: "/parts/radiator_support.webp" },

  { name: "radio-cd-dvd-sat-tv", image: "/parts/stereo.webp" },

  { name: "rear-bumper", image: "/parts/bumper.webp" },

  { name: "rear-drive-shaft", image: "/parts/drive_shaft.webp" },

  { name: "rear-garnish", image: "/parts/garnish_light.webp" },

  { name: "right-door-mirror", image: "/parts/mirror.webp" },

  { name: "right-driveshaft", image: "/parts/drive_shaft.webp" },

  { name: "right-front-door", image: "/parts/door.webp" },

  { name: "right-front-door-window", image: "/parts/door_window\.webp" },

  { name: "right-front-hub-assembly", image: "/parts/hub_assembly.webp" },

  { name: "right-front-lower-control-arm", image: "/parts/control_arm.webp" },

  { name: "right-front-strut", image: "/parts/strut.webp" },

  { name: "right-front-upper-control-arm", image: "/parts/control_arm.webp" },

  { name: "right-guard-liner", image: "/parts/right_guard_liner.webp" },

  { name: "right-headlamp", image: "/parts/headlamp.webp" },

  { name: "right-rear-door-window", image: "/parts/door_window\.webp" },

  { name: "right-rear-hub-assembly", image: "/parts/hub_assembly.webp" },

  { name: "right-rear-strut", image: "/parts/strut.webp" },

  { name: "right-rear-trailing-arm", image: "/parts/trailing_arm.webp" },

  { name: "right-rear-wnd-reg-motor", image: "/parts/window_reg_motor.webp" },

  { name: "right-taillight", image: "/parts/left_taillight.webp" },

  { name: "right-rear-door-sliding", image: "/parts/door.webp" },

  { name: "roof-glass-sunroof-t", image: "/parts/roof_glass_sunroof.webp" },

  { name: "seatbelt-stalk", image: "/parts/seat_belt.webp" },

  { name: "starter", image: "/parts/starter_motor.webp" },

  { name: "steering-pump", image: "/parts/steering_pump.webp" },

  { name: "steering-intermediate-shaft", image: "/parts/steering_intermediate_shaft.webp" },

  { name: "sunvisor", image: "/parts/sun_visor.webp" },

  { name: "trans-gearbox", image: "/parts/trans_gearbox.webp" },

  { name: "turbo-supercharger", image: "/parts/supercharger-turbocharger.webp" },

  { name: "washer-bottle", image: "/parts/washer_bottle.webp" },

  { name: "abs-booster-assembly", image: "/parts/abs_booster_assembly.webp" },

  { name: "abs-wheel-speed-sensor", image: "/parts/abs_wheel_speed_sensor.webp" },

  { name: "ac-evaporator-core", image: "/parts/ac_evaporator_core.webp" },

  { name: "ac-receiver-drier", image: "/parts/AC_receiver_drier.webp" },

  { name: "air-cleaner-duct", image: "/parts/air_cleaner_duct.webp" },

  { name: "air-flow-meter", image: "/parts/air_flow_meter.webp" },

  { name: "air-ride-compressor", image: "/parts/air_ride_compressor.webp" },

  { name: "antenna", image: "/parts/antenna.webp" },

  { name: "armrest", image: "/parts/armrest.webp" },

  { name: "bodydoor-mould", image: "/parts/bodydoor_mould.webp" },

  { name: "bonnet-lock-support", image: "/parts/bonnet_lock_support.webp" },

  { name: "bumper", image: "/parts/bumper.webp" },

  { name: "cable", image: "/parts/cable.webp" },

  { name: "caliper", image: "/parts/caliper.webp" },

  { name: "camshaft", image: "/parts/camshaft.webp" },

  { name: "car-steering", image: "/parts/car_steering.webp" },

  { name: "clutch-master-cylinder", image: "/parts/clutch_master_cylinder.webp" },

  { name: "coil-springs", image: "/parts/coil_springs.webp" },

  { name: "coilcoil-pack", image: "/parts/coilcoil_pack.webp" },

  { name: "console", image: "/parts/console.webp" },

  { name: "control-arm", image: "/parts/control_arm.webp" },

  { name: "cooler", image: "/parts/cooler.webp" },

  { name: "crankshaft", image: "/parts/crankshaft.webp" },

  { name: "cylinder-head", image: "/parts/cylinder_head.webp" },

  { name: "door", image: "/parts/door.webp" },

  { name: "door-handle", image: "/parts/door_handle.webp" },

  { name: "door-trim", image: "/parts/door_trim.webp" },

  { name: "door-window", image: "/parts/door_window\.webp" },

  { name: "drive-shaft", image: "/parts/drive_shaft.webp" },

  { name: "engine-mount", image: "/parts/engine_mount.webp" },

  { name: "fan-shroud", image: "/parts/fan_shroud.webp" },

  { name: "flasherhazard-relay", image: "/parts/flasherhazard_relay.webp" },

  { name: "flywheel-flexplate", image: "/parts/flywheel_flexplate.webp" },

  { name: "front-diff-assembly", image: "/parts/front_diff_assembly.webp" },

  { name: "fuel-door-filler", image: "/parts/fuel_door_filler.webp" },

  { name: "fuel-injector", image: "/parts/fuel_injector.webp" },

  { name: "fuel-tank", image: "/parts/fuel_tank.webp" },

  { name: "fuse-box", image: "/parts/fuse_box.webp" },

  { name: "garnish-light", image: "/parts/garnish_light.webp" },

  { name: "handbrake-lever", image: "/parts/handbrake_lever.webp" },

  { name: "hatch-strut", image: "/parts/hatch_strut.webp" },

  { name: "headlamp", image: "/parts/headlamp.webp" },

  { name: "headrest", image: "/parts/headrest.webp" },

  { name: "high-level-stoplight", image: "/parts/high_level_stoplight.webp" },

  { name: "high-voltage-battery", image: "/parts/high_voltage_battery.webp" },

  { name: "hub-assembly", image: "/parts/hub_assembly.webp" },

  { name: "ignition-w-key", image: "/parts/ignition_w_key.webp" },

  { name: "indicator-fog-side", image: "/parts/indicator_fog_side.webp" },

  { name: "injection-rail", image: "/parts/injection_rail.webp" },

  { name: "interior-mirror", image: "/parts/interior_mirror.webp" },

  { name: "leaf-spring", image: "/parts/leaf_spring.webp" },

  { name: "lock-mechanism", image: "/parts/lock_mechanism.webp" },

  { name: "manifold", image: "/parts/manifold.webp" },

  { name: "mirror", image: "/parts/mirror.webp" },

  { name: "misc", image: "/parts/misc.avif" },

  { name: "misc-bracket", image: "/parts/misc_bracket.webp" },

  { name: "misc-switchrelay", image: "/parts/misc_switchrelay.webp" },

  { name: "oil-pan", image: "/parts/oil_pan.webp" },

  { name: "oil-pump", image: "/parts/oil_pump.webp" },

  { name: "oxygen-sensor", image: "/parts/oxygen_sensor.webp" },

  { name: "pedal-assembly", image: "/parts/pedal_assembly.webp" },

  { name: "plenum-chamber", image: "/parts/plenum_chamber.webp" },

  { name: "prop-shaft", image: "/parts/prop_shaft.webp" },

  { name: "rear-diff-assembly", image: "/parts/rear_diff_assembly.webp" },

  { name: "rear-spoiler", image: "/parts/rear_spoiler.webp" },

  { name: "rear-tailgate-glass", image: "/parts/rear_tailgate_glass.webp" },

  { name: "right-guard", image: "/parts/right_guard.webp" },

  { name: "seat-belt", image: "/parts/seat_belt.webp" },

  { name: "shock-absorber", image: "/parts/shock_absorber.webp" },

  { name: "side-glass", image: "/parts/side_glass.webp" },

  { name: "side-stepskirt", image: "/parts/side_stepskirt.webp" },

  { name: "sports-bar", image: "/parts/sports_bar.webp" },

  { name: "stabilizer-bar", image: "/parts/stabilizer_bar.webp" },

  { name: "starter-motor", image: "/parts/starter_motor.webp" },

  { name: "steering-box-rack", image: "/parts/steering_box_rack.webp" },

  { name: "steering-column", image: "/parts/steering_column.webp" },

  { name: "steering-wheel", image: "/parts/steering_wheel.webp" },

  { name: "stereo", image: "/parts/stereo.webp" },

  { name: "strut", image: "/parts/strut.webp" },

  { name: "sun-visor", image: "/parts/sun_visor.webp" },

  { name: "sunroof-motor", image: "/parts/sunroof_motor.webp" },

  { name: "supercharger-turbocharger", image: "/parts/supercharger-turbocharger.webp" },

  { name: "suspension", image: "/parts/suspension.webp" },

  { name: "switch-relay", image: "/parts/switch_relay.webp" },

  { name: "thermostat-housing", image: "/parts/thermostat_housing.webp" },

  { name: "throttle-body", image: "/parts/throttle_body.webp" },

  { name: "timing-casecover", image: "/parts/timing_casecover.webp" },

  { name: "tonneau-cover", image: "/parts/tonneau_cover.webp" },

  { name: "towbar", image: "/parts/towbar.webp" },

  { name: "trailing-arm", image: "/parts/trailing_arm.webp" },

  { name: "transfer-case", image: "/parts/transfer_case.webp" },

  { name: "trim-panel", image: "/parts/trim_panel.webp" },

  { name: "water-pump", image: "/parts/water_pump.webp" },

  { name: "wheel-arch-flare", image: "/parts/wheel_arch_flare.webp" },

  { name: "wheel-coverhub-cap", image: "/parts/wheel_coverhub_cap.webp" },

  { name: "window-reg-motor", image: "/parts/window_reg_motor.webp" },

  { name: "wiper-motor", image: "/parts/wiper_motor.webp" },

  { name: "wiper-switch", image: "/parts/wiper_switch.webp" },

  { name: "xmember", image: "/parts/xmember.webp" },

  { name: "2nd-seat-rear-seat", image: "/parts/2nd Seat (Rear Seat).png" },

  { name: "3rd-seat", image: "/parts/3rd Seat.png" },

  { name: "a-c-dryer", image: "/parts/AC Dryer.png" },

  { name: "a-c-evaporator", image: "/parts/AC Evaporator.png" },

  { name: "a-c-hoses", image: "/parts/AC Hoses.png" },

  { name: "abs-sensor", image: "/parts/Abs Sensor.png" },

  { name: "air-cleaner-duct-hos", image: "/parts/Air Cleaner DuctHos.png" },

  { name: "axle", image: "/parts/Axle.png" },

  { name: "battery-tray", image: "/parts/Battery Tray.png" },

  { name: "belt-tensioner", image: "/parts/Belt Tensioner.png" },

  { name: "body-door-mould", image: "/parts/BodyDoor Mould.png" },

  { name: "c-locking-solenoid", image: "/parts/C-Locking Solenoid.png" },

  { name: "cargo-barrier", image: "/parts/Cargo Barrier.png" },

  { name: "clock", image: "/parts/\_Clock.png" },

  { name: "clutch-master-cylind", image: "/parts/Clutch Master Cylind.png" },

  { name: "coil-coil-pack", image: "/parts/CoilCoil Pack.webp" },

  { name: "complete-rear-suspen", image: "/parts/Complete Rear Suspension.webp" },

  { name: "conv-lift-motor", image: "/parts/Conv Lift Motor.png" },

  { name: "crank-cam-sensor", image: "/parts/CrankCam Sensor.png" },

  { name: "crankshaft-pulley", image: "/parts/Crankshaft Pulley.webp" },

  { name: "cruise-control-unit", image: "/parts/Cruise Control Unit.png" },

  { name: "cylinder-block", image: "/parts/Cylinder Block.png" },

  { name: "door-boot-gate-lock", image: "/parts/DoorBootGate Lock.png" },

  { name: "egr-valve", image: "/parts/Egr Valve.png" },

  { name: "engine-cover", image: "/parts/Engine Cover.png" },

  { name: "exhaust-system", image: "/parts/Exhaust System.png" },

  { name: "fan-speed-resistor", image: "/parts/Fan Speed Resistor.png" },

  { name: "flasher-hazard-relay", image: "/parts/FlasherHazard Relay.webp" },

  { name: "floor-mats", image: "/parts/Floor Mats.png" },

  { name: "frame", image: "/parts/Frame.png" },

  { name: "front-prop-shaft", image: "/parts/Front Prop Shaft.png" },

  { name: "front-seat", image: "/parts/Front Seat.png" },

  { name: "front-spoiler", image: "/parts/Front Spoiler.png" },

  { name: "front-tie-rod", image: "/parts/Front Tie Rod.png" },

  { name: "front-torsion-bar", image: "/parts/Front Torsion Bar.png" },

  { name: "frt-xmember-cradle", image: "/parts/frt-xmember-cradle.png" },

  { name: "fuel-filter-housing", image: "/parts/Fuel Filter Housing.png" },

  { name: "fuel-sending-unit", image: "/parts/Fuel Sending Unit.webp" },

  { name: "gauge", image: "/parts/Gauge.png" },

  { name: "gear-linkage", image: "/parts/Gear Linkage.png" },

  { name: "glove-box", image: "/parts/Glove Box.png" },

  { name: "glow-plug", image: "/parts/Glow Plug.png" },

  { name: "handbrake-actuator", image: "/parts/Handbrake Actuator.png" },

  { name: "header-panel", image: "/parts/header-panel.png" },

  { name: "heater-core-box", image: "/parts/Heater CoreBox.png" },

  { name: "injector-pump", image: "/parts/Injector Pump.png" },

  { name: "jack", image: "/parts/Jack.png" },

  { name: "jack-tool-kit", image: "/parts/JackTool Kit.png" },

  { name: "left-front-door-window", image: "/parts/Left Front Door Window\.webp" },

  { name: "left-front-upper-control-arm", image: "/parts/Left Front Upper Control Arm.webp" },

  { name: "left-guard", image: "/parts/Left Guard.png" },

  { name: "left-guard-liner", image: "/parts/Left Guard Liner.webp" },

  { name: "left-headlight-surround", image: "/parts/Left Headlight Surround.webp" },

  { name: "left-indicator-fog-side", image: "/parts/left-indicator-fog-side.png" },

  { name: "left-quarter-panel", image: "/parts/Left Quarter Panel.png" },

  { name: "left-rear-1-4-door-glass", image: "/parts/Left Rear 14 Door Glass.png" },

  { name: "left-rear-side-glass", image: "/parts/Left Rear Side Glass.png" },

  { name: "master-cylreservoir", image: "/parts/Master Cyl.Reservoir.webp" },

  { name: "misc-pulley", image: "/parts/Misc Pulley.webp" },

  { name: "misc-switch-relay", image: "/parts/Misc SwitchRelay.png" },

  { name: "mount", image: "/parts/Mount.webp" },

  { name: "oil-filter", image: "/parts/Oil Filter.png" },

  { name: "oil-pan-sump", image: "/parts/Oil PanSump.webp" },

  { name: "parcel_shelf_cargo_blind", image: "/parts/PARCEL_SHELF_CARGO_BLIND.png" },

  { name: "power-steer-hose", image: "/parts/Power Steer Hose.png" },

  { name: "r-beam-cradle-xmembr", image: "/parts/r-beam-cradle-xmembr.png" },

  { name: "rear-axle-beam-fwd", image: "/parts/Rear Axle Beam (Fwd).png" },

  { name: "rear-coil-spring", image: "/parts/Rear Coil Spring.webp" },

  { name: "rear-leaf-spring", image: "/parts/Rear Leaf Spring.webp" },

  { name: "rear-sway-bar", image: "/parts/Rear Sway Bar.webp" },

  { name: "reverse_camera", image: "/parts/REVERSE CAMERA.webp" },

  { name: "right-front-window-reg-motor", image: "/parts/Right Front Window RegMotor.webp" },

  { name: "right-indicator-fog-side", image: "/parts/right-indicator-fog-side.png" },

  { name: "right-quarter-panel", image: "/parts/Right Quarter Panel.png" },

  { name: "right-rear-1-4-door-glass", image: "/parts/Right Rear 14 Door Glass.png" },

  { name: "right-rear-side-glass", image: "/parts/Right Rear Side Glass.webp" },

  { name: "right_rear_door_sliding", image: "/parts/right_rear_door_sliding.png" },

  { name: "rocker-assy-cover", image: "/parts/rocker-assy-cover.png" },

  { name: "roof", image: "/parts/Roof.png" },

  { name: "roof-rack-bars", image: "/parts/Roof RackBars.png" },

  { name: "shift-actuator", image: "/parts/Shift Actuator.webp" },

  { name: "side-step-skirt", image: "/parts/side-step-skirt.png" },

  { name: "silencer", image: "/parts/Silencer.png" },

  { name: "slave-cylinder", image: "/parts/slave-cylinder.png" },

  { name: "slip-yoke", image: "/parts/slip-yoke.png" },

  { name: "snorkel", image: "/parts/snorkel.png" },

  { name: "solenoid", image: "/parts/Solenoid.png" },

  { name: "spare-wheel-carrier", image: "/parts/spare-wheel-carrier.png" },

  { name: "spare-wheel-winch", image: "/parts/spare-wheel-winch.png" },

  { name: "speedo-drive", image: "/parts/Speedo Drive.png" },

  { name: "stabiliser-bar", image: "/parts/stabiliser-bar.png" },

  { name: "steering-column-shro", image: "/parts/steering-column-shro.png" },

  { name: "steering_intermediate_shaft", image: "/parts/steering_intermediate_shaft.png" },

  { name: "supercharger", image: "/parts/supercharger.png" },

  { name: "tailgate-handle", image: "/parts/tailgate-handle.png" },

  { name: "timing-case-cover", image: "/parts/timing-case-cover.png" },

  { name: "tps-idle-speed-motor", image: "/parts/tps-idle-speed-motor.png" },

  { name: "trans-lines", image: "/parts/trans-lines.png" },

  { name: "tyre", image: "/parts/tyre.png" },

  { name: "ute-back", image: "/parts/ute-back.png" },

  { name: "ute-tray-liner", image: "/parts/ute-tray-liner.webp" },

  { name: "vacuum-air-pump", image: "/parts/vacuum-air-pump.png" },

  { name: "water-pipes-outlets", image: "/parts/water-pipes-outlets.png" },

  { name: "wheel-cover-hub-cap", image: "/parts/wheel-cover-hub-cap.png" },

  { name: "wheel-mag", image: "/parts/wheel-mag.png" },

  { name: "wheel-standard-steel", image: "/parts/wheel-standard-steel.png" },

  { name: "windshield", image: "/parts/windshield.png" },

  { name: "wiper-arm", image: "/parts/wiper-arm.png" },

  { name: "wiper-linkage", image: "/parts/Wiper Linkage.png" },

  { name: "wire-harness", image: "/parts/wire-harness.png" },

];

const MAKES_DATA = [

  { name: "abarth", image: "/make/Abarth-logo.png" },

  { name: "alfa", image: "/make/Alfa Romeo Logo.png" },

  { name: "alfa romeo", image: "/make/Alfa Romeo Logo.png" },

  { name: "alfa romio", image: "/make/Alfa Romeo Logo.png" },

  { name: "alpina", image: "/make/Alpina.png" },

  { name: "aston martin", image: "/make/Aston Martin.png" },

  { name: "audi", image: "/make/Audi Logo.png" },

  { name: "bentley", image: "/make/Bentley.png" },

  { name: "bmw", image: "/make/BMW Logo.png" },

  { name: "chery", image: "/make/Chery.png" },

  { name: "chevrolet", image: "/make/Chevrolet.png" },

  { name: "citroen", image: "/make/citroen.png" },

  { name: "chrysler", image: "/make/Chrysler.png" },

  { name: "daihatsu", image: "/make/Daihatsu.png" },

  { name: "dodge", image: "/make/Dodge Logo.png" },

  { name: "denz", image: "/make/Denz.png" },

  { name: "daewoo", image: "/make/Daewoo.png" },

  { name: "farrari", image: "/make/Farrari.png" },
  { name: "ferrari", image: "/make/Farrari.png" },

  { name: "fiat", image: "/make/Fiat Logo.png" },

  { name: "ford", image: "/make/Ford Logo.png" },

  { name: "foton", image: "/make/Foton.png" },

  { name: "genesis", image: "/make/Genesis.png" },

  { name: "gelly", image: "/make/Geely.png" },

  { name: "gwm", image: "/make/GWM.png" },

  { name: "great wall", image: "/make/GWM.png" },
  { name: "great wall motor", image: "/make/GWM.png" },

  { name: "haval", image: "/make/Haval Logo.png" },

  { name: "holden", image: "/make/Holden Logo.png" },

  { name: "honda", image: "/make/Honda Logo.png" },

  { name: "hyundai", image: "/make/Hyundai Logo.png" },

  { name: "infiniti", image: "/make/Infiniti Logo.png" },

  { name: "iveco", image: "/make/Iveco.png" },

  { name: "jaguar", image: "/make/Jaguar Logo.png" },

  { name: "jeep", image: "/make/Jeep Logo.png" },

  { name: "kia", image: "/make/Kia Logo.png" },

  { name: "ldv", image: "/make/LDV.png" },

  { name: "lexus", image: "/make/Lexus.webp" },

  { name: "land rover", image: "/make/Land Rover Logo.png" },

  { name: "lamborghini", image: "/make/Lamborghini.png" },

  { name: "leapmotor", image: "/make/Leapmotor.png" },

  { name: "mahindra", image: "/make/Mahindra.png" },

  { name: "mazda", image: "/make/Mazda Logo.png" },

  { name: "mclaren", image: "/make/MClaren.png" },

  { name: "mercedes", image: "/make/Mercedes Benz Logo.png" },

  { name: "mercedes-benz", image: "/make/Mercedes Benz Logo.png" },

  { name: "mg", image: "/make/MG Logo.png" },

  { name: "mini", image: "/make/MINI Logo.png" },

  { name: "mitsubishi", image: "/make/Mitsubishi Logo.png" },

  { name: "isuzu", image: "/make/isuzu.png" },

  { name: "nissan", image: "/make/Nissan Logo.png" },

  { name: "peugeot", image: "/make/Peugeot Logo.png" },

  { name: "porsche", image: "/make/Porsche.png" },

  { name: "proton", image: "/make/Proton.png" },

  { name: "ram", image: "/make/RAM.png" },

  { name: "renault", image: "/make/Renault Logo.png" },

  { name: "rolls royce", image: "/make/Rolls Royce.png" },

  { name: "rolls-royce", image: "/make/Rolls Royce.png" },

  { name: "skoda", image: "/make/Skoda Logo.png" },

  { name: "ssangyong", image: "/make/Ssangyong Logo.png" },

  { name: "subaru", image: "/make/Subaru Logo.png" },

  { name: "suzuki", image: "/make/Suzuki Logo.png" },

  { name: "tata", image: "/make/Tata.png" },

  { name: "tesla", image: "/make/Tesla.png" },

  { name: "toyota", image: "/make/Toyota Logo.png" },

  { name: "triumph", image: "/make/Triumph.png" },

  { name: "volkswagen", image: "/make/Volkswagen Logo.png" },

  { name: "vw", image: "/make/Volkswagen Logo.png" },

  { name: "volvo", image: "/make/Volvo Logo.png" },

  { name: "xpeng", image: "/make/Xpeng.png" },

  { name: "zeeks", image: "/make/Zeekr.png" },

];

export { MAKES_DATA, PARTS_DATA }